import { observer } from "mobx-react";
import CreateRmaFuqStore from "../stores/create-rma-fuq-store";
import { SelectDropdown } from "../../../components/inputs/select-dropdown/select-dropdown";
import { IOption } from "../../../components/inputs/select-dropdown-grouped/select-dropdown-grouped";
import useTranslation from "../../../translation/hooks/translation-hook";
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";

interface singleChoiceFuqQuestionProps {
    question: CreateRmaFuqStore;
    required?: boolean;
}

const SingleChoiceCRmaFuqAnswer: React.FC<singleChoiceFuqQuestionProps> = observer(({question, required= false}) => {

    const { getTranslation } = useTranslation();
    const { getTranslation: _getDashboardTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-create-rma';

    const dropDownOptions: IOption[] = question.answers.map((answer) => { 
        return {
            label: getTranslation(answer.displayName),
            value: answer.id!
        };
    });

    const onSelectedAnswer = (answerId: number) => {
        const selectedAnswer = question.answers.find(answer => answer.id === answerId);
        /** should never happen */
        if (!selectedAnswer) {
            console.log(`no answer was found for answer id ${answerId}`);
            return;
        }
        question.resetAllAnswersSelections();
        question.setSelectedAnswer(selectedAnswer, getTranslation);
    } 

    const getSelectedOption = () => {
        const selectedAnswer = question.answers.find(answer => answer.isSelected);
        return dropDownOptions.find(option => option.value === selectedAnswer?.id);
    }

    return(
        <SelectDropdown 
            options={dropDownOptions}
            value={getSelectedOption()}
            onChange={(v) => onSelectedAnswer(v?.value as number)}
            required={required}
            placeholder={_getDashboardTranslation('SELECT_PLACEHOLDER', pageScope)}
        />  
    );
      

});
export default SingleChoiceCRmaFuqAnswer;